import {Controller} from "stimulus"
import toastr from "toastr";

export default class extends Controller {
    static values = {
        message: String,
        type: String
    }

    connect() {
        if (this.messageValue) {
            toastr[this.typeValue](this.messageValue)
        }
    }
}